import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classes from './SPTransformerVoltageSelector.css';
import ThreeOptionsSelector from '../../../../UI/Selectors/ThreeOptionsSelector/ThreeOptionsSelector';
import TransfomerTable from '../../../TransformerTable/TransformerTable';

class SPTransformerVoltageSelector extends Component {
  state = {
    selectedVoltage: '120V'
  };

  handleOption1Selection = () => {
    this.setState({
      selectedVoltage: '120V'
    });
  };

  handleOption2Selection = () => {
    this.setState({
      selectedVoltage: '240V'
    });
  };

  handleOption3Selection = () => {
    this.setState({
      selectedVoltage: '600V'
    });
  };

  render() {
    const { selectedVoltage } = this.state;
    const { country, language } = this.props;
    return (
      <div className={classes.SPTransformerVTComponent}>
        <ThreeOptionsSelector
          selectedOption={selectedVoltage}
          option1="120V"
          option2="240V"
          option3="600V"
          selectedOption1={this.handleOption1Selection}
          selectedOption2={this.handleOption2Selection}
          selectedOption3={this.handleOption3Selection}
        />
        <TransfomerTable
          phase="single"
          voltage={selectedVoltage}
          country={country}
          language={language}
        />
      </div>
    );
  }
}

SPTransformerVoltageSelector.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default SPTransformerVoltageSelector;
